import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "master-detail-caption" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxMasterDetail = _resolveComponent("DxMasterDetail")!
  const _component_GridOrganigramaDetalii = _resolveComponent("GridOrganigramaDetalii")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsOrganigrama,
      ref: "dataGridRef",
      "allow-column-reordering": false,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "Id"
    }, {
      detaliiTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_1, " Detalii pentru organigrama: " + _toDisplayString(data.data.Nume), 1),
        _createVNode(_component_GridOrganigramaDetalii, { "template-data": data }, null, 8, ["template-data"])
      ]),
      editTitle: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px 0 10px 20px","width":"100%"} }, " Editare Organigrama ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: "Cauta ..."
        }),
        _createVNode(_component_DxMasterDetail, {
          enabled: true,
          template: "detaliiTemplate"
        }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: "500px",
              height: "530px",
              "show-title": true,
              "title-template": "editTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.saveButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  "data-field": "Cod",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Nume",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "StareID",
                  "editor-type": "dxSelectBox",
                  "editor-options": {dataSource: _ctx.dsOrganigrameStari, 
                        displayExpr: 'Nume', 
                        valueExpr: 'Id', 
                        placeholder: 'Selectează o stare...',
                        height: 50,
                        showClearButton: true}
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxItem, {
                  "data-field": "Versiune",
                  "editor-type": "dxNumberBox",
                  "editor-options": _ctx.numberBoxOptions
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxItem, {
                  "data-field": "AprobareDocument",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Observatii",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "ValidData",
                  "editor-options": { height: 50, displayFormat: 'dd-MM-yyyy' }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "AprobareData",
                  "editor-options": { height: 50, displayFormat: 'dd-MM-yyyy' }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Valid",
                  "editor-type": "dxCheckBox",
                  "css-class": 'checkbox-center',
                  "editor-options": { elementAttr: { style: 'display:flex; justify-content:center; margin-left:120px' } }
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cod",
          caption: "Cod"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Nume",
          caption: "Nume"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "StareID",
          caption: "Stare",
          "calculate-display-value": "Stare.Nume"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Versiune",
          caption: "Versiune"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValidData",
          caption: "Valid Data",
          "data-type": "date"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Valid",
          caption: "Valid (calculat)"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AprobareDocument",
          caption: "Aprobare Document"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AprobareData",
          caption: "Aprobare Data",
          "data-type": "date"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Observatii",
          caption: "Observatii"
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, {
              location: "after",
              name: "searchPanel"
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "show-title": true,
      width: "500px",
      height: "500px"
    }, {
      title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare Organigrama ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, { "col-count": 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Cod",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newOrganigrama.Cod,
                  onValueChanged: _ctx.onCodValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Nume",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newOrganigrama.Nume,
                  onValueChanged: _ctx.onNumeValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Stare" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxLookup, {
                  "data-source": _ctx.dsOrganigrameStari,
                  "display-expr": "Nume",
                  "value-expr": "Id",
                  value: _ctx.newOrganigrama.StareID,
                  onValueChanged: _ctx.onStareIDValueChanged,
                  height: "50px"
                }, null, 8, ["data-source", "value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Versiune" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxNumberBox, {
                  min: 0,
                  step: 1,
                  "show-spin-buttons": true,
                  "show-clear-button": true,
                  value: _ctx.newOrganigrama.Versiune,
                  onValueChanged: _ctx.onVersiuneValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Aprobare Document" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newOrganigrama.AprobareDocument,
                  onValueChanged: _ctx.onAprobDocValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Observatii" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newOrganigrama.Observatii,
                  onValueChanged: _ctx.onObservatiiValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Valid Data" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxDateBox, {
                  value: _ctx.newOrganigrama.ValidData,
                  type: "date",
                  "display-format": "dd-MM-yyyy",
                  "show-clear-button": true,
                  "label-mode": "floating",
                  height: "50px",
                  onValueChanged: _ctx.onValidDataValueChanged
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Aprobare Data" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxDateBox, {
                  value: _ctx.newOrganigrama.AprobareData,
                  type: "date",
                  "display-format": "dd-MM-yyyy",
                  "show-clear-button": true,
                  "label-mode": "floating",
                  height: "50px",
                  onValueChanged: _ctx.onAprobDataValueChanged
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Valid (calculat)",
              "col-span": 2
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_DxCheckBox, {
                    value: _ctx.newOrganigrama.Valid,
                    onValueChanged: _ctx.onValidValueChanged
                  }, null, 8, ["value", "onValueChanged"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}